import {
  GET_INDUSTRY_EPISODES,
  GET_INDUSTRY_EPISODE,
  INDUSTRY_ERROR,
} from "../actions/types";

const initialState = {
  episodes: [],
  currentepisode: {},
  industryloading: true,
  episodesloading: true,
  episodeserror: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_INDUSTRY_EPISODES:
      return {
        ...state,
        episodes: payload,
        episodesloading: false,
      };
    case GET_INDUSTRY_EPISODE:
      return {
        ...state,
        currentepisode: payload,
        episodesloading: false,
      };
    case INDUSTRY_ERROR:
      return {
        ...state,
        episodeserror: payload,
        episodesloading: false,
      };
    default:
      return state;
  }
}
